import Bugsnag, {NotifiableError, OnErrorCallback} from '@bugsnag/js';
import {AnalyticsBase} from 'extensions/analytics/base';
import {AppUserGroup} from 'store/slices/app/types';
import {BUGSNAG} from 'config/keys';
import {version} from 'config/app';

const gtag = typeof window['gtag'] !== 'undefined'
  ? window['gtag']
  : () => {};

const loaded = {
  bugsnag: false,
  gtag: false,
};

class Analytics implements AnalyticsBase {
  start(appName: string, userId: string, userGroup: AppUserGroup) {
    // Bugsnag
    try {
      Bugsnag.start({
        context: 'myfiles',
        apiKey: BUGSNAG,
        appType: process.env.REACT_APP_STAGE || 'production',
        appVersion: process.env.REACT_APP_VERSION || version,
        user: userId ? {id: userId} : undefined,
        enabledBreadcrumbTypes: ['log', 'user', 'state', 'error', 'manual', 'process', 'request'],
        maxBreadcrumbs: 50,
      });
      loaded.bugsnag = true;
    } catch (e) {}

    // Google Analytics
    try {
      gtag('config', {
        user_id: userId,
        dimension7: appName,
        dimension1: userGroup < AppUserGroup.Free
          ? 'unregistered'
          : userGroup === AppUserGroup.Free
            ? 'basic'
            : 'premium',
      });
      loaded.gtag = true;
    } catch (e) {}
  }

  gtag(name: string, params?: {[key: string]: any}) {
    if (!loaded.gtag) return;
    try {
      gtag('event', name, params);
    } catch (e) {}
  }

  screen(name: string) {
    if (!loaded.gtag) return;
    try {
      gtag('event', 'screen_view', {screen_name: name});
    } catch (e) {}
  }

  log(value: string) {
    loaded.bugsnag && Bugsnag.leaveBreadcrumb(value);
  }

  notify(error: NotifiableError, onError?: OnErrorCallback) {
    if (!loaded.bugsnag) return;
    Bugsnag.notify(error, onError);
  }
}

export default new Analytics();
